import { useQuery, useMutation, useQueryClient } from 'react-query';
import AsnAPI, { PrintingOnboardingResponse } from '../Api/asn';

export const useGetPrintingOnboardingStatus = (userId: number) =>
  useQuery<PrintingOnboardingResponse>(
    ['printing-onboarding-status', userId],
    () => AsnAPI.getPrintingOnboardingTestStatus(userId),
    {
      enabled: !!userId,
      onError: (error) => {
        console.error('Error fetching print status:', error);
      },
    },
  );

export const useUpdatePrintingOnboardingStatus = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({
      userId,
      data,
    }: {
      userId: number;
      data: {
        printed_samples: { unit: boolean; carton: boolean; hangtag: boolean };
      };
    }) => AsnAPI.upsertPrintingOnboardingTestLabels(userId, data),
    {
      onSuccess: (_, { userId }) => {
        queryClient.invalidateQueries(['printing-onboarding-status', userId]);
      },
    },
  );
};
